import { Injectable } from '@angular/core';
import { DocumentModel } from 'src/app/shared/models/document.model';

import { CHANNEL } from '../../../constants/channel.constants';

import { IChannelCommunicatorInterface } from '../../../interfaces/channel-communicator.interface';
import { AppInfoModel } from '../../../models/app-info.model';
import { DeviceInfoModel } from '../../../models/device-info.model';
import { AbreCuentasService } from '../../abre-cuentas/abre-cuentas.service';
import { LoadingService } from '../../loading/loading.service';
import { ParametersService } from '../../parameters/parameters.service';
import { MockAppImplService } from './implementation/mockapp/mockapp-impl.service';
import { PortalOperadorImplService } from './implementation/portaloperador-impl.service';
import { PortalPnImplService } from './implementation/portalpn-impl.service';
import { PortalPnCnImplService } from './implementation/portalpncn-impl.service';
import { SuperappImplService } from './implementation/superapp-impl.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { IProductsModel } from 'src/app/shared/models/products.model';

@Injectable()

/**
 * Clase que determina el canal de comunicación
 *
 * Class that determines the communication channel
 */
export class ChannelCommunicatorService {

  /**
   * Inicializaión de la variable channelId como string
   *
   * *Set channelId variable as string*
   *
   * @access              private
   * @type                {string}
   */
  private channelId: string;

  /**
   * Inicializaión de la variable impl como IChannelCommunicatorInterface, implementación del canal
   *
   * *Set impl variable as IChannelCommunicatorInterface, channel implementation*
   *
   * @access              public
   * @type                {IChannelCommunicatorInterface}
   */
  impl: IChannelCommunicatorInterface;

  /**
   * Summary      Constructor of the component.
   *
   * @var {AbreCuentasService}  abreCuentasService  Injectable abreCuentasService service.
   */
  constructor(
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private loading: LoadingService,
  ) { }

  /**
   * Inicializa el parámetro channelId
   *
   * *Sets up channelId parameter*
   *
   * @param {string} code
   */
  setChannelId(code: string): void {
    this.channelId = code;
    this.abreCuentasService.chanelid = code;
    switch (this.channelId) {
      case CHANNEL.MOCKAPP.CODE:
        this.impl = new MockAppImplService(this.parametersService);
        break;
      case CHANNEL.SUPERAPP.CODE:
        this.impl = new SuperappImplService(this.loading);
        break;
      case CHANNEL.PORTALPN.CODE:
        this.impl = new PortalPnImplService();
        break;
      case CHANNEL.PORTALO.CODE:
        this.impl = new PortalOperadorImplService();
        break;
      case CHANNEL.PORTALPN2.CODE:
        this.impl = new PortalPnCnImplService();
        break;
      case CHANNEL.PORTALALLIES.CODE:
        // this.impl = new PortalAllyImplService();
        break;
    }
  }

  /**
   * Obtiene el parámetro de channelId
   *
   * @returns this.channelId parameter
   */
  getChannelId(): string {
    return this.channelId;
  }

  /**
   * Obtiene el parámetro de Impl
   *
   * @returns this.Impl parameter
   */
  getImpl(): IChannelCommunicatorInterface {
    return this.impl;
  }

  /**
   * Valida el canal de comunicación por medio del channel_id, para desarrollo se utiliza el canal 131
   *
   * *Verify Channel Communication by the channel_id parameter, To development environment it is used channel 131*
   *
   */
  async validateChannel() {
    const url_mock_sdk = this.parametersService.getParameter('url_mock_sdk');

    if (url_mock_sdk) {
      this.setChannelId(CHANNEL.MOCKAPP.CODE);
      await this.callInfoClient();
      return;
    }

    const channelId = this.abreCuentasService.getQueryParamByName('channel_id', window.location.search);

    if (channelId.length > 0) {
      this.setChannelId(channelId);
      if (channelId === '163') {
        const codeAlly = this.abreCuentasService.getQueryParamByName('code_ally', window.location.search);
        this.abreCuentasService.setAllyCode(codeAlly);
      }
    } else {
      this.setChannelId(CHANNEL.SUPERAPP.CODE);
    }
    await this.callInfoClient();
  }

  /**
   * Obtiene e inicializa la información de la Aplicación
   *
   * *Gets and Sets app information*
   */
  async retreiveAndSetAppInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getImpl().getAppInfo()
        .then(response => {
          const channelInfo = new AppInfoModel();
          channelInfo.infoUnavailable = (response.code === '404');
          channelInfo.channelId = response.data.channelId;
          channelInfo.platform = response.data.platform;
          channelInfo.appVersion = response.data.appVersion;
          this.abreCuentasService.setAppInfo(channelInfo);
          resolve('');
        })
        .catch(err => reject(err));
    });
  }

  /**
   * Obtiene e inicializa la información del dispositivo
   *
   * *Gets and Sets device information*
   */
  async retreiveAndSetDeviceInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getImpl().getDeviceInfo()
        .then(response => {
          const deviceInfo = new DeviceInfoModel();
          deviceInfo.device_id = response.data.device.device_id;
          deviceInfo.brand = response.data.device.brand;
          deviceInfo.os_version = response.data.device.os_version;
          deviceInfo.model = response.data.device.model;
          this.abreCuentasService.setDeviceInfo(deviceInfo);
          resolve('');
        })
        .catch(err => reject(err));
    });
  }

    /**
     * Transferencia a enrolamiento
     *
     * *transfer to enlistment*
     */

  async openEnrollment(_sesionId: any): Promise<any> {
    return new Promise(resolve => {
      this.getImpl()
              .openPage(
              _sesionId,
                5,
                false,
              ).then(response => {
                console.log('reponse', response);
                resolve('');
              });
    });
  }
  /**
   * Establece el canal de comunicación de acuerdo al parámetro de channel id
   *
   * *Establishes the communication channel according to channel id parameter*
   */
  getChannelStyle() {

    /* Cambio para bug OE-23063 : Start */

    return this.channelId === CHANNEL.SUPERAPP.CODE ? 'default' : 'portalpn';
    // return this.channelId === CHANNEL.PORTALPN.CODE || this.channelId === CHANNEL.PORTALALLIES.CODE ? 'portalpn' : 'default';

    /* Cambio para bug OE-23063 : End */

  }

  /**
   * Valida la informacion del para identificar si el flujo va por pre o post login
   *
   * *Verify user info to select flow preLogin or postLogin*
   *
   */
  async callInfoClient() {
    console.log('canal', this.channelId);
    switch (this.channelId) {
      case '163':
        this.abreCuentasService.setPostlogin(false);
        break;
      case '159':
        await this.getImpl().getInfoClient().then(_response => {
          const data = _response.data;
          this.abreCuentasService.setSeller(data.document);
        });
        break;
      default:
        if (this.abreCuentasService.getUserJemelii()) {
          console.log('canal default is user jemelli');
          this.abreCuentasService.setPostlogin(false);
          return;
        }
        await this.getImpl().getInfoClient().then(_response => {
          if (_response.code !== '200') {
            this.abreCuentasService.setPostlogin(false);
            return;
          }
          const data = _response.data;
          const documenInfo = new DocumentModel();
          documenInfo.document_type = data.document.type;
          documenInfo.document_number = parseInt(data.document.number, 10).toString();
          this.abreCuentasService.setDocumentInfo(documenInfo);
          this.abreCuentasService.setPostlogin(true);
        });
        break;
    }

    // if (this.channelId === '163') {
    //   this.abreCuentasService.setPostlogin(false);
    // } else {
    //   await this.getImpl().getInfoClient().then(_response => {
    //     if (_response.code !== '200') {
    //       this.abreCuentasService.setPostlogin(false);
    //       return;
    //     }
    //     const data = _response.data;
    //     console.log('response.data', _response.data);
    //     const documenInfo = new DocumentModel();
    //     documenInfo.document_type = data.document.type;
    //     documenInfo.document_number = parseInt(data.document.number, 10).toString();
    //     this.abreCuentasService.setDocumentInfo(documenInfo);
    //     this.abreCuentasService.setPostlogin(true);
    //   });
    // }

  }

}
